<template>
    <div>
        <div class="show-navigation">
            <chat-header></chat-header>

            <div class="container">
                <chat-menu></chat-menu>

                <div class="form-control-wrapper mb--30">
                    <svg class="icon"><use xlink:href="/img/icon-sprite.svg#search"></use></svg>
                    <input type="text" placeholder="Search" v-model="search" class="form-control form-control--sm form-control--gray" />
                </div>

                <template v-if="myChats !== null">
                    <div v-for="chat in chats" @click="goToChat(chat.id)" :class="{'profile--active': isUnread(chat)}" class="profile profile--horizontal profile--horizontal-sm mb--10 cursor--pointer">
                        <figure class="profile__avatar">
                    <span class="profile__avatar__img">
                        <img :src="chatWith(chat).user.avatar" alt="">
                    </span>
                        </figure>

                        <div class="profile__text">
                            <div class="profile__name">{{ chatWith(chat).user.nick }}</div>
                            <div class="profile__text__bottom">
                                <span>{{ chat.lastMessage.message }}</span>
                                <time :datetime="chat.lastMessage.created_at">{{ chat.lastMessage.group_date }}</time>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <navigation></navigation>
    </div>
</template>

<script>
import api from "../../api/chat";
import {mapState} from "vuex";
import Navigation from "../partial/Navigation";
import ChatMenu from "./partial/chatMenu";
import ChatHeader from "./partial/chatHeader";

export default {
    name: "Messages",

    components: {ChatHeader, ChatMenu, Navigation},

    data: function () {
        return {
            myChats: null,
            search: '',
        }
    },

    computed: {
        ...mapState('auth', [
            'user'
        ]),

        chats() {
            return collect(this.myChats)
                .when(this.search.length > 0, (chats) => chats.filter((chat) => this.chatWith(chat).user.nick.search(this.search) > -1))
        }
    },

    methods: {
        loadMyChats() {
            api.loadMyChats().then((response) => {
                this.myChats = response.data.data
            })
        },

        isUnread(chat) {
            if (! chat.lastMessage) {
                return false;
            }

            return chat.lastMessage.read_at === null && chat.lastMessage.user.id !== this.user.id
        },

        chatWith(chat) {
            return collect(chat.users)
                .filter((item) => item.user.id !== this.user.id)
                .first()
        },

        goToChat(chatId) {
            this.$router.push('/chat/'+chatId)
        }
    },

    created() {
        this.loadMyChats()

        Quiz.$on('newChatMessage', () => {
            this.loadMyChats()
        })
    },

    mounted() {
        $('body').addClass('body--white')
    },

    beforeDestroy() {
        Quiz.$off('newChatMessage')
        $('body').removeClass('body--white')
    }
}
</script>
